import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useOnClickOutside } from '../components/shared/dropDownMenu/hooks';
import { selectIsMobile } from '../selectors/app';

const mapStateToProps = (state) => ({
  isMobile: selectIsMobile(state),
});

export default function withOutsideClickControl(
  MyComponent,
  shouldAlwaysAddRef,
) {
  const WithOutsideClickControl = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerProps = {};
    const isMobile = props.isMobile;

    // Generally, React Hooks should be written at the top of a function and never wrapped in a
    // conditional. These are special cases because `shouldAlwaysAddRef ` won't change in a
    // given HO instance and `isMobile` won't change in a given app instance,
    // so this shouldn't cause any unwanted behavior.
    // Source: https://reactjs.org/docs/hooks-rules.html
    /* eslint-disable react-hooks/rules-of-hooks */
    if (shouldAlwaysAddRef || !isMobile) {
      const containerRef = useRef();
      useOnClickOutside(containerRef, () => setIsOpen(false));
      containerProps.ref = containerRef;
    }
    /* eslint-enable react-hooks/rules-of-hooks */

    const handleOnClick = (val) => {
      const value = typeof val === 'boolean' ? val : !isOpen;
      setIsOpen(value);
    };

    return (
      <MyComponent
        {...props}
        handleOnClick={handleOnClick}
        isOpen={isOpen}
        containerProps={containerProps}
        isMobile={isMobile}
      />
    );
  };

  WithOutsideClickControl.propTypes = {
    isMobile: PropTypes.bool.isRequired,
  };

  return connect(mapStateToProps)(WithOutsideClickControl);
}
